export const SETTINGS_TITLES = {
  WORKSPACE_DETAILS: 'Workspace Details',
  USER_MANAGEMENT: 'User Management',
  CUSTOM_FIELDS: 'Custom Fields',
  FACIAL_RECOGNITION: 'Facial Recognition',
  YOUR_TAGS: 'Your Tags',
  CDN_LINKS: 'CDN Links',
  SHARE_LINK_DEFAULTS: 'Share Link Defaults',
  CURRENT_PLAN: 'Current Plan',
  INVOICES_BILLING: 'Invoices & Billing',
  ADD_ONS: 'Add-ons',
  SECURITY_IDENTITY: 'Security & Identity',
  AUDIT_LOGS: 'Audit Logs',
  ACCOUNT_SETTINGS: 'Account Settings',
  CHANGE_PASSWORD: 'Change Password',
  NOTIFICATIONS: 'Notifications',
  API_ACCESS: 'API Access',
  INTEGRATIONS: 'Integrations',
  ADS_ACCOUNTS: 'Ad Insights Accounts',
  IMPORT_HISTORY: 'Import History',
} as const;

export type SettingsTitle = (typeof SETTINGS_TITLES)[keyof typeof SETTINGS_TITLES];

/** Strato settings-page subtitles — used by ui2026 `SettingsPageTitle` only. */
export const SETTINGS_SUBTITLES: Record<SettingsTitle, string> = {
  [SETTINGS_TITLES.WORKSPACE_DETAILS]: 'Name, logo, and workspace defaults',
  [SETTINGS_TITLES.USER_MANAGEMENT]: 'Invite and manage workspace access',
  [SETTINGS_TITLES.CUSTOM_FIELDS]: 'Metadata fields for assets and boards',
  [SETTINGS_TITLES.FACIAL_RECOGNITION]: 'People identification and privacy controls',
  [SETTINGS_TITLES.YOUR_TAGS]: 'Workspace tag library and defaults',
  [SETTINGS_TITLES.CDN_LINKS]: 'Managed delivery links for assets',
  [SETTINGS_TITLES.SHARE_LINK_DEFAULTS]: 'Default permissions for new share links',
  [SETTINGS_TITLES.CURRENT_PLAN]: 'Plan tier, seats, and renewal',
  [SETTINGS_TITLES.INVOICES_BILLING]: 'Payment method and billing history',
  [SETTINGS_TITLES.ADD_ONS]: 'Optional workspace capabilities',
  [SETTINGS_TITLES.SECURITY_IDENTITY]: 'SSO, domains, and access policies',
  [SETTINGS_TITLES.AUDIT_LOGS]: 'Workspace activity and security events',
  [SETTINGS_TITLES.ACCOUNT_SETTINGS]: 'Profile, email, and sign-in',
  [SETTINGS_TITLES.CHANGE_PASSWORD]: 'Update your account password',
  [SETTINGS_TITLES.NOTIFICATIONS]: 'Email and in-app notification preferences',
  [SETTINGS_TITLES.API_ACCESS]: 'Personal API tokens and access',
  [SETTINGS_TITLES.INTEGRATIONS]: 'Connected apps and channels',
  [SETTINGS_TITLES.ADS_ACCOUNTS]: 'Connected ad platform accounts',
  [SETTINGS_TITLES.IMPORT_HISTORY]: 'Past imports and sync activity',
};

const isSettingsTitle = (title: string): title is SettingsTitle => title in SETTINGS_SUBTITLES;

export const getSettingsSubtitle = (title: string | undefined) => {
  if (!title || !isSettingsTitle(title)) {
    return undefined;
  }

  return SETTINGS_SUBTITLES[title];
};
